/*
 * @Autor: dingxiaolin
 * @Date: 2021-01-06 16:36:42
 * @LastEditors: qiuwenjing qiuwenjing@vip56.cn
 * @LastEditTime: 2025-09-16 15:42:10
 */
// import QRCode from 'qrcodejs2';
import QRCode from 'qrcode'
/**
 * 金额数字转千分位
 * @param s 金额
 * @param n 保留小数位数
 */
export function fmoney(s, n = 2, unit = false) {
    n = n > 0 && n <= 20 ? n : 2;
    s = parseFloat((s + '').replace(/[^\d\.-]/g, '')).toFixed(n) + '';
    return (
        (unit ? '￥' : '') +
        s
    );
}
export function getPayText(val) {
    let str = "组合";
    switch (val) {
        case 1:
            str = "会员卡"
            break;
        case 2:
            str = "现金"
            break;
        case 3:
            str = "微信"
            break;
        case 4:
            str = "支付宝"
            break;
        case 13:
            str = "线下微信"
            break;
        case 14:
            str = "线下支付宝"
            break;

        default:
            break;
    }
    return str;
}
/**
 * 去尾法
 */
export function tailFun(val, num = 2) {
    let str = "";
    val = Number(val).toFixed(2);
    if (val.toString().indexOf('.') > -1) {
        let pos = val.toString().indexOf('.');
        str = num == 0 ? val.toString().slice(0, pos + num) : val.toString().slice(0, pos + num + 1);
    } else {
        str = val + '.0'
    }
    return str;
}
export function fmoneyNew(s, unit = true) {
    let fh = Number(s) < 0 ? '-' : ''
    let val = Math.abs(Number(s))
    return (
        fh + (unit ? '￥' : '') + val
    );
}
/**
 * 千分位金额转数字
 * @param s 千分位金额
 */
function rmoney(s) {
    return parseFloat(s.replace(/[^\d\.-]/g, ''));
}

/**
 * 金额转大写人民币汉字
 */
export function convertMoney(money) {
    //汉字的数字
    var cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖');
    //基本单位
    var cnIntRadice = new Array('', '拾', '佰', '仟');
    //对应整数部分扩展单位
    var cnIntUnits = new Array('', '万', '亿', '兆');
    //对应小数部分单位
    var cnDecUnits = new Array('角', '分', '毫', '厘');
    //整数金额时后面跟的字符
    var cnInteger = '整';
    //整型完以后的单位
    var cnIntLast = '元';
    //最大处理的数字
    var maxNum = 999999999999999.9999;
    //金额整数部分
    var integerNum;
    //金额小数部分
    var decimalNum;
    //输出的中文金额字符串
    var chineseStr = '';
    //分离金额后用的数组，预定义
    var parts;
    if (money == '') {
        return '';
    }
    money = parseFloat(money);
    if (money >= maxNum) {
        //超出最大处理数字
        return '';
    }
    if (money == 0) {
        chineseStr = cnNums[0] + cnIntLast + cnInteger;
        return chineseStr;
    }
    //转换为字符串
    money = money.toString();
    if (money.indexOf('.') == -1) {
        integerNum = money;
        decimalNum = '';
    } else {
        parts = money.split('.');
        integerNum = parts[0];
        decimalNum = parts[1].substr(0, 4);
    }
    //获取整型部分转换
    if (parseInt(integerNum, 10) > 0) {
        var zeroCount = 0;
        var IntLen = integerNum.length;
        for (var i = 0; i < IntLen; i++) {
            var n = integerNum.substr(i, 1);
            var p = IntLen - i - 1;
            var q = p / 4;
            var m = p % 4;
            if (n == '0') {
                zeroCount++;
            } else {
                if (zeroCount > 0) {
                    chineseStr += cnNums[0];
                }
                //归零
                zeroCount = 0;
                chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
            }
            if (m == 0 && zeroCount < 4) {
                chineseStr += cnIntUnits[q];
            }
        }
        chineseStr += cnIntLast;
    }
    //小数部分
    if (decimalNum != '') {
        var decLen = decimalNum.length;
        for (var i = 0; i < decLen; i++) {
            var n = decimalNum.substr(i, 1);
            if (n != '0') {
                chineseStr += cnNums[Number(n)] + cnDecUnits[i];
            }
        }
    }
    if (chineseStr == '') {
        chineseStr += cnNums[0] + cnIntLast + cnInteger;
    } else if (decimalNum == '') {
        chineseStr += cnInteger;
    }
    return chineseStr;
}
export function getArCode(data) {
    let baseURL = process.env.NODE_ENV === "development" ? 'https://posm.hftopos.com/vipMpTest?shopId=' : 'https://posm.hftopos.com/vipMp?shopId='
    //  var qrCode = new QRCode(document.getElementById("qrcode"), {
    //         text: baseURL + data.shopId, // 要编码的文本（可以是网址、文本等）
    //         width: 50, // 二维码的宽度
    //         height: 50, // 二维码的高度
    //         colorDark: "#000000", // 二维码的前景色（深色）
    //         correctLevel: QRCode.CorrectLevel.H // 容错率，H 是最高级别
    //     });
        
    //     let childs = document.getElementById("qrcode").childNodes;
        
    //     for(let i = childs.length -2 ; i>=0 ; i--){
    //         document.getElementById("qrcode").removeChild(childs[i]);
    //     }
    //     console.log('childs',childs)
    //     console.log('qrCode',qrCode)
    //     console.log('qrCode1',qrCode._oDrawing)
    //     console.log('qrCode2',qrCode._oDrawing._elImage)
    //     console.log('qrCode3',qrCode._oDrawing._elImage.currentSrc)
    let url = '';
    let shopId = JSON.parse(localStorage.getItem('padShopInfo')).id;
    QRCode.toDataURL(baseURL + shopId, {
        margin: 1,
        width: 100,
        height: 100,
        errorCorrectionLevel: 'H'
      }).then((url) => {
        url = url
        localStorage.setItem('qrCodeValue',JSON.stringify(url))
          console.log('url',url)
          return url
      })

}

export default {
    fmoney,
    rmoney,
    convertMoney,
    tailFun,
    fmoneyNew,
    getPayText,
    getArCode,
};



// WEBPACK FOOTER //
// ./src/common/money.js